
import CardContenedorAdmin from '../components/CardContenedorAdmin'
import useVacacionesEmpleado from '../hooks/useVacacionesEmpleado'
import { PencilIcon, Volver } from '../assets/icons'
import { Button, Card } from 'react-bootstrap'
import { Toaster } from 'react-hot-toast'
import DataTable from 'react-data-table-component'
import FullCalendar from '@fullcalendar/react'
import multiMonthPlugin from '@fullcalendar/multimonth'
import ModalAsignarVacaciones from '../components/ModalAsignarVacaciones'
import Cargando from '../components/Cargando'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'
import TooltipHover from '../components/TooltilHover'


export default function VacacionesEmpleado() {

    const { nombreEmpleado, columns, eventos,
        handleCloseForm, showForm, handleShowForm, handleDatesSet, cambiarDiasVacaciones
    } = useVacacionesEmpleado();
    const listaVacacionesEmpleado = useEmpleadoStore(state => state.listaVacacionesEmpleado);
    const cargandoVacacionesEmpleado = useEmpleadoStore(state => state.cargandoVacacionesEmpleado);
    const objLogueado = useEmpleadoStore(state => state.objLogueado);
    const diasVacaciones = useEmpleadoStore(state => state.diasVacaciones)
    const diasVacacionesSumados = useEmpleadoStore(state => state.diasVacacionesSumados)

    if (!objLogueado.permitido) {
        window.location = "/"
        return (<></>)
    }


    const DiasVacacionesText = () => {
        if (diasVacaciones === null) {
            return 'Cargando...'
        } else if (diasVacaciones === false) {
            return 'Sin asignar'
        } else {
            return `${diasVacaciones} días`
        }
    }

    const DiasVacacionesRestantesText = () => {
        if (diasVacaciones === null) {
            return 'Cargando...'
        }
		if (diasVacaciones === false) {
            return 'Sin asignar'
		}

		const dias_restantes = diasVacaciones - diasVacacionesSumados

		if ( dias_restantes === -1 ) {
			return `Se asignó ${dias_restantes * -1} día más de los permitidos.`
		} else if ( dias_restantes < 0 ) {
			return `Se asignaron ${dias_restantes * -1} días más de los permitidos.`
        } else {
            return `Restan ${dias_restantes} días`
        }
    }


    return (
        <CardContenedorAdmin>

            <div className='d-flex justify-content-between'>
                <Button variant='link' className='mb-3 d-flex flex-row align-items-center gap-2 link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover' onClick={() => window.history.back()}>
                    <Volver /> Volver
                </Button>

                <p className="lead">Vacaciones {nombreEmpleado && `de ${nombreEmpleado}`} </p>
                <div></div>
            </div>


            {/* tabla */}
            <Card className='my-5'>
                <Card.Body>

                    {/* grid de arriba */}
                    <div className="row">
                        <div className="col">
                            <Button variant='primary' onClick={handleShowForm}>
                                Asignar vacaciones
                            </Button>
                        </div>
                        <div className="col">&nbsp;</div>
                        <div className="col d-flex justify-content-center align-items-center">
                            <label className="me-2">
                                <DiasVacacionesText />
                            </label>
                            {diasVacaciones !== null
                                ? <TooltipHover tooltipText={'Cambiar días'}>
                                    <Button variant='link' onClick={cambiarDiasVacaciones}>
                                        <PencilIcon />
                                    </Button>
                                </TooltipHover>
                                : ''}
                        </div>
                        <div className="col">&nbsp;</div>
                    </div>


                    {/* tabla */}
                    <DataTable
                        responsive
                        columns={columns}
                        data={listaVacacionesEmpleado}
                        highlightOnHover
                        noDataComponent='No hay datos para mostrar en esta tabla'
                        progressPending={cargandoVacacionesEmpleado}
                        progressComponent={<Cargando cargando={cargandoVacacionesEmpleado} />}
                    />

                    {/* grid de abajo */}
                    <div className="row">
                        <div className="col"></div>
                        <div className="col">&nbsp;</div>
                        <div className="col d-flex justify-content-center align-items-center">
                            <label className="me-2">
                                <DiasVacacionesRestantesText />
                            </label>
                        </div>
                        <div className="col">&nbsp;</div>
                    </div>
                </Card.Body>
            </Card>


            {/* calendario */}
            <FullCalendar
                locale={'es'}
                headerToolbar={{
                    left: '',
                    center: 'title',
                    right: 'prev,next',
                }}
                initialView="multiMonthYear"
                events={eventos}
                plugins={[multiMonthPlugin]}
                buttonText={{ today: 'Hoy' }}
                views={{
                    dayGridMonth: { buttonText: 'Mes' },
                    multiMonthYear: { buttonText: 'Meses', type: 'multiMonthYear' }
                }}
                datesSet={handleDatesSet}
            />


            <ModalAsignarVacaciones handleClose={handleCloseForm} show={showForm} />
            <Toaster />
        </CardContenedorAdmin>
    )
}

